import React from "react";
import "../../../plans.scss";

export default function FreePlan() {
  return (
    <div className="col s4 m4 l4 Enterprise">
      <div className="plan-card">
        <div className="tag-price">
          <h3>Free</h3>
          <div className="row price-box">
            <div className="col s12 m12 l12">
              {" "}
              <p>Limited feature access to Vizcom products and services</p>
            </div>
          </div>
        </div>

        <ul>
          <li>Access to Vizcom Classic</li>

          <li>60 renders a month</li>
        </ul>
        <div className="row buttons">
          <div className="col s12 m12  l12 "></div>
        </div>
      </div>
    </div>
  );
}
